/* Loft56 homepage-animaties (vanilla JS, geen libraries).
   - Draait NIET bij prefers-reduced-motion: reduce
   - Content start altijd zichtbaar; dit script verrijkt alleen (progressive enhancement)
   - Wordt door meerdere secties geladen; guard voorkomt dubbel initialiseren */
(function () {
  if (window.__lfHome) return;
  window.__lfHome = true;
  var doc = document.documentElement;
  doc.classList.add('lf-js');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  doc.classList.add('lf-anim');
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  function init() {
    /* 1. reveals bij scroll (IntersectionObserver) */
    var revealEls = [].slice.call(document.querySelectorAll('[data-lf-reveal]'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lf-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('lf-in'); });
    }

    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var mx = 0, my = 0, smx = 0, smy = 0;
    if (fine) {
      window.addEventListener('mousemove', function (e) {
        mx = e.clientX / window.innerWidth - 0.5;
        my = e.clientY / window.innerHeight - 0.5;
      }, { passive: true });
    }

    var heroes = [].slice.call(document.querySelectorAll('[data-lf-hero]'));
    var drifts = [].slice.call(document.querySelectorAll('[data-lf-drift]'));
    var pans = [].slice.call(document.querySelectorAll('[data-lf-pan]'));

    /* 2. scrollgedreven zoom-parallax op de hero + zachte drift/pan elders */
    function frame() {
      requestAnimationFrame(frame);
      var vh = window.innerHeight;
      smx += (mx - smx) * 0.06;
      smy += (my - smy) * 0.06;

      heroes.forEach(function (hero) {
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var span = hero.offsetHeight - vh;
        var p = span > 0 ? Math.max(0, Math.min(1, -rect.top / span)) : 0;
        var ez = p * p * (3 - 2 * p);
        var media = hero.querySelector('[data-lf-hero-media]');
        if (media) media.style.transform = 'translate(' + (smx * -1).toFixed(3) + 'vw,' + (smy * -0.7).toFixed(3) + 'vh) scale(' + (1.06 + 0.18 * ez).toFixed(4) + ')';
        var copy = hero.querySelector('[data-lf-hero-copy]');
        if (copy) {
          var out = Math.max(0, Math.min(1, (p - 0.75) / 0.25));
          copy.style.opacity = (1 - out).toFixed(3);
          copy.style.transform = 'translateY(' + (-out * 26).toFixed(1) + 'px)';
        }
        var hint = hero.querySelector('[data-lf-hero-hint]');
        if (hint) hint.style.opacity = Math.max(0, 1 - p * 6).toFixed(2);
      });

      drifts.forEach(function (el) {
        if (el.hasAttribute('data-lf-reveal') && !el.classList.contains('lf-in')) return;
        var r = el.getBoundingClientRect();
        if (r.bottom < -300 || r.top > vh + 300) return;
        if (!el.dataset.lfDriftOn) { el.dataset.lfDriftOn = '1'; el.style.transitionProperty = 'opacity'; }
        var rel = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translateY(' + (rel * parseFloat(el.getAttribute('data-lf-drift') || '0')).toFixed(1) + 'px)';
      });

      pans.forEach(function (im) {
        var c = (im.parentElement || im).getBoundingClientRect();
        if (c.bottom < 0 || c.top > vh) return;
        var rel = (c.top + c.height / 2 - vh / 2) / vh;
        im.style.transform = 'translateY(' + (rel * parseFloat(im.getAttribute('data-lf-pan') || '0')).toFixed(2) + '%) scale(1.12)';
      });
    }
    requestAnimationFrame(frame);

    /* 3. 3D-tilt met glare op kaarten (alleen muis/desktop) */
    if (fine) {
      [].slice.call(document.querySelectorAll('[data-lf-tilt]')).forEach(function (card) {
        if (card.dataset.lfTiltOn) return;
        card.dataset.lfTiltOn = '1';
        if (card.parentElement) card.parentElement.style.perspective = '900px';
        var media = card.querySelector('.lf-zoom');
        var glare = null;
        if (media) {
          media.style.position = 'relative';
          glare = document.createElement('div');
          glare.setAttribute('aria-hidden', 'true');
          glare.style.cssText = 'position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s ease;z-index:3';
          media.appendChild(glare);
        }
        card.addEventListener('mousemove', function (ev) {
          var r = card.getBoundingClientRect();
          var nx = (ev.clientX - r.left) / r.width - 0.5;
          var ny = (ev.clientY - r.top) / r.height - 0.5;
          card.style.transition = 'transform .12s ease-out';
          card.style.transform = 'rotateY(' + (nx * 9).toFixed(2) + 'deg) rotateX(' + (-ny * 9).toFixed(2) + 'deg) translateZ(12px)';
          if (glare) {
            glare.style.opacity = '1';
            glare.style.background = 'radial-gradient(420px circle at ' + ((nx + 0.5) * 100).toFixed(1) + '% ' + ((ny + 0.5) * 100).toFixed(1) + '%,rgba(255,255,255,.3),transparent 55%)';
          }
        });
        card.addEventListener('mouseleave', function () {
          card.style.transition = 'transform .8s ' + EASE;
          card.style.transform = '';
          if (glare) glare.style.opacity = '0';
        });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
